import React from "react"
import { Dialog } from "@reach/dialog"
import "@reach/dialog/styles.css"

interface AddToCalendarModalProps {
  eventTitle: string
  googleUrl?: string
  outlookUrl?: string
  icsUrl?: string
  onClose: () => void
}

// Same pattern as EmailBandDialog: show the choices, let the fan pick where
// to add the event instead of hardcoding one calendar provider for everyone.
export const AddToCalendarModal: React.FC<AddToCalendarModalProps> = ({
  eventTitle,
  googleUrl,
  outlookUrl,
  icsUrl,
  onClose,
}) => {
  return (
    <Dialog
      isOpen
      onDismiss={onClose}
      aria-label={`Add ${eventTitle} to calendar`}
      style={{ maxWidth: 360, width: "90%" }}
    >
      <div className="flex justify-end mb-2">
        <button
          className="close-button focus:outline-none text-lg"
          onClick={onClose}
          type="button"
        >
          <span aria-hidden>×</span>
        </button>
      </div>

      <div className="text-xs font-semibold text-gray-500 uppercase mb-2">
        Add to Calendar
      </div>
      <div className="flex flex-col gap-2">
        {googleUrl && (
          <a
            href={googleUrl}
            target="_blank"
            rel="noreferrer"
            className="text-center px-3 py-2 rounded border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 focus:outline-none"
          >
            Google / Android
          </a>
        )}
        {icsUrl && (
          <a
            href={icsUrl}
            download={`${eventTitle}.ics`}
            className="text-center px-3 py-2 rounded border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 focus:outline-none"
          >
            Apple / ics
          </a>
        )}
        {outlookUrl && (
          <a
            href={outlookUrl}
            target="_blank"
            rel="noreferrer"
            className="text-center px-3 py-2 rounded border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 focus:outline-none"
          >
            Outlook
          </a>
        )}
      </div>
    </Dialog>
  )
}

export default AddToCalendarModal
